<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Quote Management</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :items-per-page="5"
            :headers="headersNotfound"
            :items="itemNotfound"
            hide-default-footer
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :headers="quoteHeader"
            :items="headerItemsFilterDate"
            :items-per-page="5"
            hide-default-footer
            class="elevation-1 table-header"
            @click:row="handleRowClick"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Quote Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in quoteHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curQuote[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curQuote[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="seeDetail">
                      See Quote Details
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in quoteHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel id="detail" style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >Quote Details</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <!-- <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate2" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate2" class="input_date" />
            </div>
          </div> -->
          <br />
          <tableComponent
            :tableHeaders="quoteDetail"
            :tableItems="detailItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQQuote();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      quoteHeader: [
        { text: "Quote", value: "QuoteHed_QuoteNum" },
        { text: "Cust Name", value: "Customer_Name" },
        { text: "Address", value: "Calculated_Address" },
        { text: "Date Quoted", value: "QuoteHed_DateQuoted" },
        { text: "Expires", value: "QuoteHed_ExpirationDate" },
        { text: "PO Num", value: "QuoteHed_PONum" },
        { text: "Terms", value: "QuoteHed_TermsCode" },
        { text: "Amount", value: "QuoteHed_DocQuoteAmt" },
        { text: "Currency Code", value: "QuoteHed_CurrencyCode" },
        { text: "QSalesRP Name", value: "QSalesRP_Name" },
        { text: "Status", value: "Calculated_Winlose" },
      ],
      quoteDetail: [
        { text: "Quote", value: "QuoteDtl_QuoteNum" },
        { text: "Line", value: "QuoteDtl_QuoteLine" },
        { text: "Part", value: "QuoteDtl_PartNum" },
        { text: "Cust Part", value: "QuoteDtl_XPartNum" },
        { text: "Description", value: "QuoteDtl_LineDesc" },
        { text: "Revision", value: "QuoteDtl_RevisionNum" },
        { text: "Order Qty", value: "QuoteDtl_OrderQty" },
        { text: "Expected Qty", value: "QuoteDtl_SellingExpectedQty" },
        { text: "UOM", value: "QuoteDtl_SellingExpectedUM" },
        { text: "Unit Price", value: "QuoteDtl_DocExpUnitPrice" },
        { text: "Doc Discount", value: "QuoteDtl_DocDiscount" },
        { text: "Ordered", value: "QuoteDtl_Ordered" },
        { text: "Draw", value: "QuoteDtl_DrawNum" },
      ],
      headerItems: [],
      detailItems: [],
      panel: [],
      curQuote: {},
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      dialog: false,
      emptyItem: " ",
      fromdate2: "",
      todate2: "",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getQuoteHead() {
      this.loadHeader();
    },
    getQuoteDtl() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getQuoteHead", "getQuoteDtl"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.QuoteHed_QuoteNum.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.QuoteHed_DateQuoted.split("/")[0];
          let month = i.QuoteHed_DateQuoted.split("/")[1];
          let year = i.QuoteHed_DateQuoted.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.QuoteDtl_QuoteLine.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.QuoteDtl_PartNum.toString().toLowerCase().indexOf(filterKey) > -1 ||
          i.QuoteDtl_LineDesc.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        // let from = new Date(this.fromdate2);
        // let to = new Date(this.todate2)
        // return this.detailItemsFilter.filter((i) => {
        //   let day = i..split('/')[0];
        //   let month = i..split('/')[1];
        //   let year = i..split('/')[2];
        //   let date = new Date(year, month-1, day);
        //   return date <= to && from <= date;
        // });
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQQuoteDetail(this.curQuote);
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    handleRowClick(item) {
      this.dialog = true;
      this.curQuote = item;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    async getBAQQuote() {
      await this.$store.dispatch("Data/getQuoteHeadData");
      this.loadHeader();
    },
    async getBAQQuoteDetail(item) {
      await this.$store.dispatch("Data/getQuoteDtlData", {
        quotenum: item.QuoteHed_QuoteNum,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getQuoteHead && this.getQuoteHead.length > 0) {
        this.getQuoteHead.forEach((el) => {
          this.headerItems.push({
            QuoteHed_QuoteNum: el.QuoteHed_QuoteNum,
            Customer_Name: el.Customer_Name,
            Calculated_Address: el.Calculated_Address,
            QuoteHed_DateQuoted: this.convertDate(el.QuoteHed_DateQuoted),
            QuoteHed_ExpirationDate: this.convertDate(
              el.QuoteHed_ExpirationDate
            ),
            QuoteHed_PONum: el.QuoteHed_PONum,
            QuoteHed_TermsCode: el.QuoteHed_TermsCode,
            QuoteHed_DocQuoteAmt: el.QuoteHed_DocQuoteAmt,
            QuoteHed_CurrencyCode: el.QuoteHed_CurrencyCode,
            QSalesRP_Name: el.QSalesRP_Name,
            Calculated_Winlose: el.Calculated_Winlose,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getQuoteDtl && this.getQuoteDtl.length > 0) {
        this.getQuoteDtl.forEach((el) => {
          this.detailItems.push({
            QuoteDtl_QuoteNum: el.QuoteDtl_QuoteNum,
            QuoteDtl_QuoteLine: el.QuoteDtl_QuoteLine,
            QuoteDtl_PartNum: el.QuoteDtl_PartNum,
            QuoteDtl_XPartNum: el.QuoteDtl_XPartNum,
            QuoteDtl_LineDesc: el.QuoteDtl_LineDesc,
            QuoteDtl_RevisionNum: el.QuoteDtl_RevisionNum,
            QuoteDtl_OrderQty: el.QuoteDtl_OrderQty,
            QuoteDtl_SellingExpectedQty: el.QuoteDtl_SellingExpectedQty,
            QuoteDtl_SellingExpectedUM: el.QuoteDtl_SellingExpectedUM,
            QuoteDtl_DocExpUnitPrice: el.QuoteDtl_DocExpUnitPrice,
            QuoteDtl_DocDiscount: el.QuoteDtl_DocDiscount,
            QuoteDtl_Ordered: el.QuoteDtl_Ordered,
            QuoteDtl_DrawNum: el.QuoteDtl_DrawNum,
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}
table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
</style>
